package com.arena_web.domain.usecases.auth

import com.arena_web.data.dto.AuthResponse
import com.arena_web.data.dto.RegisterRequest
import com.arena_web.domain.repositories.AuthRepository

class RegisterUseCase(private val authRepository: AuthRepository) {

    suspend operator fun invoke(
        email: String,
        username: String,
        password: String,
        fullName: String? = null
    ): Result<AuthResponse> {
        val result = authRepository.register(
            RegisterRequest(email, username, password, fullName)
        )
        result.onSuccess { saveAuthSession(it) }
        return result
    }
}
